import { render, staticRenderFns } from "./ManagerViewProjectItem.vue?vue&type=template&id=39f5faa8"
import script from "./ManagerViewProjectItem.vue?vue&type=script&lang=ts"
export * from "./ManagerViewProjectItem.vue?vue&type=script&lang=ts"
import style0 from "./ManagerViewProjectItem.vue?vue&type=style&index=0&id=39f5faa8&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f5faa8')) {
      api.createRecord('39f5faa8', component.options)
    } else {
      api.reload('39f5faa8', component.options)
    }
    module.hot.accept("./ManagerViewProjectItem.vue?vue&type=template&id=39f5faa8", function () {
      api.rerender('39f5faa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scheduler/itemComponents/ManagerViewProjectItem.vue"
export default component.exports